import { render, staticRenderFns } from "./FixedRouteServices.vue?vue&type=template&id=2ed465ea"
import script from "./FixedRouteServices.vue?vue&type=script&lang=ts"
export * from "./FixedRouteServices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports